import styled, { keyframes } from 'styled-components'

import { Color } from '../../../../config/styles/colors'
import Button from '../../../Button'

export const Loader = styled.div`
  position: absolute;

  background: ${Color.PRIMARY};

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  width: 100%;

  z-index: 1;

  bottom: 0;
  top: 0;
`

export const Logo = styled.img`
  width: 38%;
  height: auto;
  margin-bottom: 10%;
  pointer-events: none;
`

const moveHand = keyframes`
  0%   { transform: rotate(2deg) translateY(0); }
  30%  { transform: rotate(5deg) translateY(-15px); }
  50%  { transform: scale(1,1.05) rotate(5deg) translateY(0); }
  100% { transform: scale(1.05,1) rotate(10deg) translateY(0); }
`
export const Hand = styled.div`
  position: absolute;
  top: 10%;
  right: 14%;
  z-index: 3;
  margin: 1em;

  width: 14%;
  max-width: 4em;

  img {
    display: none;
    opacity: 0;

    width: 100%;
    height: auto;

    animation: ease infinite alternate;
    animation-name: ${moveHand};
    animation-duration: 1.4s;

    -webkit-animation: ease infinite alternate;
    -webkit-animation-name: ${moveHand};
    -webkit-animation-duration: 1.4s;
  }
`

export const Camera = styled.img`
  display: none;
  opacity: 0;
  position: absolute;

  width: 18%;

  max-width: 7.5em;

  height: auto;

  z-index: 2;

  top: 5%;
  right: 0;

  margin: 1em;
`

export const Back = styled.img`
  position: absolute;

  display: none;
  opacity: 0;

  width: 15%;

  max-width: 4em;
  height: auto;

  z-index: 2;

  top: 0;
  left: 0;

  margin: 1em;
`

export const ResetExperience = styled.div`
  margin: 1em;
  width: 16%;
  height: auto;

  display: none;
  opacity: 0;

  max-width: 6em;

  position: absolute;

  img {
    width: 100%;
    height: auto;
  }

  z-index: 2;

  bottom: 0;
  left: 0;
`

export const ReverseCamera = styled.div`
  margin: 1em;
  width: 15%;
  height: auto;

  max-width: 4em;

  position: absolute;

  img {
    display: none;
    opacity: 0;

    width: 100%;
    height: auto;
  }

  z-index: 2;

  top: 0;
  right: 0;
`

export const Snapshot = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  width: 100%;

  position: absolute;

  #snapshot-container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    margin: 0.5em;
  }

  img {
    display: none;
    opacity: 0;

    width: 20%;
    height: 20%;
  }

  z-index: 1;

  bottom: 0;
  left: 0;
`

const run = keyframes`
  0% { left: 70%;}
  100% { left: 0%;}

`

export const SharkOutlineContainer = styled.div`
  display: none;
  opacity: 0;

  pointer-events: none;
  position: absolute;

  z-index: 1;

  background: transparent;

  // display: flex;
  justify-content: center;
  align-items: center;

  height: 100%;

  @media only screen and (min-width: 768px) {
    #target {
      width: 50% !important;
    }

    #phone {
      width: 20% !important;
    }
  }

  #target {
    width: 85%;
  }

  #phone {
    position: absolute;
    width: 30%;
    z-index: 2;

    animation: linear infinite alternate;
    animation-name: ${run};
    animation-duration: 2s;

    -webkit-animation: linear infinite alternate;
    -webkit-animation-name: ${run};
    -webkit-animation-duration: 2s;
  }
`

export const Prompt = styled.div`
  display: none;
  opacity: 0;

  pointer-events: none;
  position: absolute;

  z-index: 1;

  bottom: 0;
  left: 0;

  #target {
    width: 32%;
    margin: 3.3em 1em;
  }

  #phone {
    position: absolute;
    width: 15%;
    z-index: 2;

    left: 0;
    bottom: 29%;

    animation: linear infinite alternate;
    animation-name: ${run};
    animation-duration: 2s;

    -webkit-animation: linear infinite alternate;
    -webkit-animation-name: ${run};
    -webkit-animation-duration: 2s;
  }
`

export const ResetButton = styled(Button)`
  position: absolute;

  display: none;
  opacity: 0;

  z-index: 2;

  bottom: 2%;
  left: 0;

  font-style: normal;

  box-shadow: rgba(0, 0, 0, 0.2) -1.5px -2px 0px inset;

  margin: 1em;

  width: auto;
  height: auto;

  font-size: 0.6em;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  font-weight: 500;
  color: #fff;

  border: none;
  border-radius: 45px;
  transition: all 0.3s ease 0s;
  cursor: pointer;
  outline: none;
`
